<div *ngFor="let type of notificationType">
  <div *ngIf="author.alerts[type] && alerts && alerts.hasOwnProperty(type) && alerts[type].length > 0" class="card">
    <img [src]="mobile ? '/assets/img/top-bar/notification_icon_active.png' : '/assets/img/top-bar/notification_icon.png'"/>
    <div [ngSwitch]="type">
      <div *ngSwitchCase="'late_link'" class="message">
        <div class="title">We still need your Link!</div>
        <div class="text" *ngIf="alerts['late_link'].length === 1">We still need your book link for your feature running on {{moment(alerts['late_link'][0].pubDate, 'YYYYMMDD').format('MMMM Do, YYYY')}} on {{alerts['late_link'][0]._site.name}}</div>
        <div class="text" *ngIf="alerts['late_link'].length > 1">
          <span>We still need your book links for the following features:</span>
          <ul>
            <li *ngFor="let late_link of alerts['late_link']">{{moment(late_link.pubDate, 'YYYYMMDD').format('MMMM Do, YYYY')}} on {{late_link._site.name}}</li>
          </ul>
        </div>
        <div class="action">
          <button type="button" class="regular button solid-green" (click)="sendMail('submit_link')">Submit Link</button>
        </div>
      </div>
      <div *ngSwitchCase="'feature_live'" class="message">
        <div class="title" *ngIf="alerts['feature_live'].length === 1">Your feature for {{alerts['feature_live'][0]._book.title}} is live!</div>
        <div class="title" *ngIf="alerts['feature_live'].length > 1">Your features are live!</div>
        <div class="text" *ngIf="alerts['feature_live'].length === 0">Your title is live</div>
        <div class="text" *ngIf="alerts['feature_live'].length > 1">
          <span>The following features are live:</span>
          <ul class="list">
            <li *ngFor="let live of alerts['feature_live']">{{live._book.title}}</li>
          </ul>
        </div>
        <div class="action">
          <a [href]="alerts['feature_live'][0]._site.domainUrl" target="_blank"><button type="button" class="regular button solid-green" (click)="dismiss('feature_live')">View your feature</button></a>
        </div>
      </div>
      <div *ngSwitchCase="'failed_feature'" class="message">
        <div class="title">There was a problem with the price of your book</div>
        <div class="text">
          We had you on the {{alerts['failed_feature'][0]._site.name}} calendar today to promote {{alerts['failed_feature'][0]._book.title}}.
          Unfortunately your book was not listed at the promotional price during our promotional window, so we will be unable to run your feature.
          Please send a message to customer service to get information on your choices going forward.
        </div>
        <div class="action">
          <button type="button" class="regular button solid-green" (click)="sendMail('failed_feature')">Contact Support</button>
        </div>
      </div>
      <div *ngSwitchCase="'cart_abandon'" class="message">
        <div class="title">Do you need help booking a promo for {{alerts['cart_abandon'][0]._book.title}}?</div>
        <div class="text">
          We noticed you started to book a {{alerts['cart_abandon'][0]._siteAdvert.name}} promotion, but didn't complete your booking.
          Are you having trouble? We're here to help! Just email us at <a href="mailto:support@writtenwordmedia.com">support&#64;writtenwordmedia.com</a> if you need assistance checking out.
        </div>
        <div class="action">
          <a [href]="'../features/'+alerts['cart_abandon'][0]._site.seoSlug+'/'+alerts['cart_abandon'][0]._siteAdvert.seoSlug+'/checkout/'+alerts['cart_abandon'][0]._id" target="_blank"><button type="button" class="regular button solid-green" (click)="dismiss('cart_abandon')">Book Feature</button></a>
        </div>
      </div>
      <div *ngSwitchCase="'survey_follow_up'" class="message">
        <div class="title">Here's a survey</div>
        <div class="text">
          Thanks for running your feature {{alerts['survey_follow_up'][0]._book.title}} by {{alerts['survey_follow_up'][0]._book.author}} on {{alerts['survey_follow_up'][0]._site.name}} on {{moment(alerts['survey_follow_up'][0].pubDate, 'YYYYMMDD').format('MMMM Do, YYYY')}}.
          We hope your promotion was successful! We are always working to make our service better. We'd appreciate if you could please take this short {{alerts['survey_follow_up'][0]._site.name}} survey to let us know how we did.
          Your feedback is valuable and helps.
        </div>
        <div class="action">
          <a [href]="alerts['survey_follow_up'][0].surveyLink" target="_blank"><button type="button" class="regular button solid-green" (click)="dismiss('survey_follow_up')">Take Survey</button></a>
        </div>
      </div>
      <div *ngSwitchCase="'prep_for_feature'" class="message">
        <div class="title">Get ready for your feature on {{moment(alerts['prep_for_feature'][0].pubDate, 'YYYYMMDD').format('MMMM Do, YYYY')}}</div>
        <div class="text">
          <p>This is to remind you that you have an upcoming promotion for {{alerts['prep_for_feature'][0]._book.title}} on {{alerts['prep_for_feature'][0]._site.name}} on {{moment(alerts['prep_for_feature'][0].pubDate, 'YYYYMMDD').format('MMMM Do, YYYY')}}.</p>
          <p *ngIf="alerts['prep_for_feature'][0]._site.name === 'Freebooksy'">
            Our book promotion elves are hard at work getting everything ready for your promotion.
            Please help them out by making sure that your book is set to be free on the day of your promotion. If your
            book is not free on the day of the promotion we will be unable to run your book and we will be unable to issue
            a refund or reschedule. This makes our elves sad. So please make sure everything is set up on your end so we
            don't have sad authors or sad elves.
          </p>
          <p *ngIf="alerts['prep_for_feature'][0]._site.name === 'Bargain Booksy'">
            Please help our elves out by making sure your book is set to its promotional price by 6AM EST on the day
            of your promotion. If you are running a Kindle Countdown Deal please double check your KDP dashboard to make
            sure your deal is scheduled. Kindle Countdown Deals usually switch prices by 11AM EST on the first day of the
            countdown deal and we will wait for the price switch before we send the email.
          </p>
          <p *ngIf="alerts['prep_for_feature'][0]._site.name === 'Bargain Booksy'">
            We will run your book if your price is $5.00 or below on the day of your promotion. If your book is priced above
            $5.00 on the day of the promotion, we will cancel your promotion and we will be unable to refund or rechedule your
            promotion. This makes our elves sad. So please make sure everything is set up on your end so we don't have sad authors or sad elves.
          </p>
          <p *ngIf="alerts['prep_for_feature'][0]._site.name === 'Red Feather Romance'">
            Please help our elves out by making sure your book is set to its promotional price (or set to free if
            you are running a free promo) by 6AM EST on the day of your promotion.
          </p>
        </div>
        <div class="action">
          <a href="https://www.writtenwordmedia.com/2017/07/11/how-to-price-your-book-for-maximum-results-during-a-promotion/" target="_blank"><button type="button" class="regular button solid-green">Read Article</button></a>
        </div>
      </div>
      <div *ngSwitchCase="'keep_in_touch'" class="message">
        <div class="title">It's been a while since we promoted {{alerts['keep_in_touch'][0]._book.title}}</div>
        <div class="text">We last featured your book, {{alerts['keep_in_touch'][0]._book.title}} as a feature two months ago.
          We know most successful authors run promotions every 90 days, and we wanted to remind you to book your next feature for your book
          today as many of our features are selling out 3-4 weeks in advance.
        </div>
        <div class="action">
          <button type="button" class="regular button solid-green" (click)="promote(alerts['keep_in_touch'][0].ASIN)">Promote Book Again</button>
        </div>
      </div>
      <div class="message-date">{{moment(alerts[type][0].pubDate, 'YYYYMMDD').format('dddd, MMMM  Do')}}</div>
    </div>
  </div>
</div>
